module.exports = __webpack_public_path__ + "img/dress6.a195de0f.jpeg";